import React from "react";
//import Autosuggest from "react-autosuggest";
import "./css/autosuggest.css";

import { FetchData } from "../services/FetchData";
import { clearWord } from "../AppClass";

import { AppContext } from "../App";

// Imagine you have a list of languages that you'd like to autosuggest.
//const languages = ["অসমীয়া", "হিংসা", "C#", "assamese"];
const languages = [];

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  console.log("getsuggestions");

  return inputLength === 0
    ? []
    : languages.filter(
        lang => lang.toLowerCase().slice(0, inputLength) === inputValue
      );
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => <div>{suggestion}</div>;

export default class MyAutoSuggest extends React.Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: "",
      suggestions: []
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });

    //console.log("val => ", newValue);
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    //console.log("fetchRequested")

    let self = this;

    window.setTimeout(function() {
      console.log("timer");

      let r = Math.random()
        .toString(36)
        .substring(7);

      //self.setState({
      //suggestions: [r,"assam","assamese","asom","bengali","big data","c plus plus"]
      //});

      FetchData("/suggest", {
        token:
          localStorage.getItem("auth_token") === null
            ? ""
            : localStorage.getItem("auth_token"),
        //email: localStorage.getItem("user_mail") === null ? "" : localStorage.getItem("user_mail"),
        word: clearWord(value)
      })
        .then(result => {
          console.log("/suggest", result);

          let jsonResult = JSON.parse(JSON.stringify(result));
          console.log(jsonResult);

          self.setState({
            suggestions: jsonResult
          });
        })
        .catch(error => {
          //alert(error);
          console.log("/suggest", error);
          //self.setState({ suggestLoading: false });
        });
    }, 0);

    this.setState({
      //suggestions: getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { value, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: "Search word",
      value,
      onChange: this.onChange
    };

    // Finally, render it!
    return (
      <div>
      {/* <AppContext.Consumer>
        {({ state, actions }) => (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
        )}
        </AppContext.Consumer> */}
        </div>
    );
  }
}
